<div class="login-container">
    <div class="login-content">
        <div class="brand-header">
            <img src="assets/images/logo.png" class="brand-logo" alt="Ryno logo" />
        </div>

        <div class="login-form-card">
            <div class="heading-block">
                <h2 class="sign-in-title">Sign in</h2>
                <p class="sign-in-subtitle">Welcome. Enter your credentials to continue.</p>
            </div>
            <form class="login-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                <div class="form-group">
                    <label for="username">Username</label>
                    <input class="form-control" type="text" formControlName="username" placeholder="user@domain.com" />
                    <div class="validation-error" *ngIf="
            loginForm.get('username')?.invalid &&
            (loginForm.get('username')?.touched || loginForm.get('username')?.dirty)
          ">
                        <small *ngIf="loginForm.get('username')?.errors?.['required']">
                            Username is required
                        </small>
                    </div>
                </div>
                <div class="form-group">
                    <div class="password-label-row">
                        <label for="password">Password</label>
                        <a class="forgot-password" routerLink="/forgot-password">Forgot password?</a>
                    </div>
                    <div class="password-input">
                        <input class="form-control" [type]="showPassword ? 'text' : 'password'" formControlName="password" placeholder="Enter password" />
                        <button class="password-toggle" type="button" (click)="togglePassword()">
                            <svg *ngIf="!showPassword" width="20" height="20" viewBox="0 0 24 24">
                                <path fill="currentColor" d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
                            </svg>
                            <svg *ngIf="showPassword" width="20" height="20" viewBox="0 0 24 24">
                                <path fill="currentColor" d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" />
                            </svg>
                        </button>
                    </div>
                    <div class="validation-error" *ngIf="
            loginForm.get('password')?.invalid &&
            (loginForm.get('password')?.touched ||
              loginForm.get('password')?.dirty)
          ">
                        <small *ngIf="loginForm.get('password')?.errors?.['required']">
                            Password is required
                        </small>
                    </div>
                </div>

                <!-- 
      <div class="form-actions">
        <div class="remember-me">
          <input class="form-check-input" type="checkbox" formControlName="remember" />
          <label for="remember">Keep me signed in</label>
        </div>
      </div> -->


                <button type="submit" class="login-button" [disabled]="!loginForm.valid" [title]="
          !loginForm.valid
            ? 'Please make sure all the fields are filled, with proper details'
            : 'Login'
        ">
                    Sign in
                    <span aria-hidden="true">&#8594;</span>
                </button>

                <div class="security-note">
                    <span class="lock-icon" aria-hidden="true">
                        <svg width="14" height="14" viewBox="0 0 24 24">
                            <path fill="currentColor" d="M12 17a2 2 0 1 0 0-4a2 2 0 0 0 0 4m6-6h-1V9A5 5 0 0 0 7 9v2H6a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2m-3 0H9V9a3 3 0 0 1 6 0z" />
                        </svg>
                    </span>
                    <span>Secured by RYNO</span>
                </div>

                <div class="register-link-wrapper">
                    <p class="text-light">
                        Don't have an account?
                        <a routerLink="/register" class="register-link text-primary">Sign Up</a>
                    </p>
                </div>
            </form>
        </div>
    </div>
</div>